import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import OutlineClose from 'react-md-icon/dist/OutlineClose';
import Skeleton from 'react-skeleton-loader';

const closeIcon = (onClear, id) => (
  <OutlineClose
    style={{
      fontSize: '1rem', float: 'right', color: 'rgba(0,0,0,.5)', cursor: 'pointer',
    }}
    onClick={() => onClear(id)}
  />
);

const renderItems = (isLoading, items, onClear) => {
  if (isLoading) {
    let i = 3;
    const skeletonArray = [];
    while (i > 0) {
      i -= 1;
      const element = (
        <tr className="body-md" key={`skeleton-${i}`}>
          <td><Skeleton width="250px" height="16px" widthRandomness="0.5" borderRadius="0" color="#ededed" /></td>
          <td className="text-right">
            <Skeleton style={{ float: 'right' }} width="16px" height="16px" widthRandomness="0" borderRadius="0" color="#ededed" />
          </td>
        </tr>
      );
      skeletonArray.push(element);
    }
    return skeletonArray;
  }
  return items.map(doc => (
    <tr className="body-md" key={doc.id}>
      <td>{doc.title ? `${doc.title} - ${doc.filename}` : doc.filename}</td>
      <td>{closeIcon(onClear, doc.id)}</td>
    </tr>
  ));
};

const ItemList = ({
  items,
  onClear,
  title,
  isLoading,
}) => (
  <Table className="table-hover mt-4">
    <thead>
      <tr className="small bg-gray-50 d-flex font-weight-bold">
        <th colSpan={2} className="border-0 docs-heading"><FormattedMessage id={title} /></th>
      </tr>
    </thead>
    <tbody className="border-bottom">
      {renderItems(isLoading, items, onClear)}
    </tbody>
  </Table>
);

ItemList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    filename: PropTypes.string,
  })).isRequired,
  onClear: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ItemList;



// WEBPACK FOOTER //
// ./src/components/ItemList/ItemList.jsx